import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import styles
import "../public/styles/mainStyles/index.scss";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "tailwindcss/tailwind.css";
import defaultlayout from "@/layouts/default.vue";

createApp(App)
  .component("default-layout", defaultlayout)
  .use(store)
  .use(router)
  .mount("#app");
